<div class="innerpage-fullwithbanner">
  <h2 class="bighead">1031 Inquiry</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="parentId === 0 &&BC_routeLink=='/1031-exchanges'"><a (click)="onBreadCrumbClick()">1031 Exchanges<span>|</span></a></li>
    <li *ngIf="parentId === 0 &&BC_routeLink!='/1031-exchanges'"><a (click)="onBreadCrumbClick()">{{BC_routeName}}<span>|</span></a></li>
    <li *ngIf="parentId !== 0&&BC_routeLink=='/1031-exchanges'">
      <a (click)="onBreadCrumbClick();">1031 Exchanges<span>|</span></a>
    </li>
    <li *ngIf="parentId !== 0&&BC_routeLink!='/1031-exchanges'">
      <a (click)="onBreadCrumbClick();">{{BC_routeName}}<span>|</span></a>
    </li>
    <li>1031 Inquiry</li>
  </ul>
</div>
<div class="registration1031 section-margin">
  <div class="container container-lg min-heightcontainer">
    <div>
      <div class="border-div margin-bottom-0" [hidden]="showSuccessDiv">
        <form [formGroup]="traderInfoForm" autocomplete="off">
          <!--<h2 class="mainhead"><span class="text">Trader Information</span></h2>-->
          <div class="row" [hidden]="true">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">First Name<span class="red">*</span></label>
                <input class="form-control" readonly formControlName="txtfirstname" [ngModel]="trade1031InputModel.firstname">
                <div *ngIf="(txtfirstname.invalid && istraderInfoSubmitted )||(txtfirstname.invalid && (txtfirstname.dirty || txtfirstname.touched))">
                  <p class="redtext" *ngIf="txtfirstname.errors.required">
                    First Name is required
                  </p>
                  <p class="redtext" *ngIf="txtfirstname.errors.minlength">
                    First Name must be at least 2 characters long
                  </p>
                  <p class="redtext" *ngIf="txtfirstname.errors.spaceOnly">
                    The value cannot be only white spaces
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Last Name<span class="red">*</span></label>
                <input class="form-control" readonly formControlName="txtlastname" [ngModel]="trade1031InputModel.lastname">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Email<span class="red">*</span></label>
                <input class="form-control" readonly formControlName="txtemail" [ngModel]="trade1031InputModel.email">
                <div *ngIf="(txtemail.invalid && istraderInfoSubmitted )||(txtemail.invalid && (txtemail.dirty || txtemail.touched))">
                  <p class="redtext" *ngIf="txtemail.errors.required">
                    Email is required
                  </p>
                  <p class="redtext" *ngIf="txtemail.errors.EmailCheck">
                    Invalid Email Address
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Phone<span class="red">*</span></label>
                <input class="form-control" readonly mask='(000) 000-0000' formControlName="txtphone" [ngModel]="trade1031InputModel.phone">
                <div *ngIf="(txtphone.invalid && istraderInfoSubmitted )||(txtphone.invalid && (txtfirstname.dirty || txtphone.touched))">
                  <p class="redtext" *ngIf="txtphone.errors.required">
                    Phone no. is required
                  </p>
                  <p class="redtext" *ngIf="txtphone.errors.minlength">
                    Invalid Phone no.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <label class="bluelabel margin-top-10 margin-bottom-15">Relinquished Property Information</label>

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Sold/Projected Sale Date
                  <span class="star">*</span>
                </label>
                <div class="textbox-date">
                  <input bsDatepicker class="form-control" autofocus (keydown)="onKeydown($event,'tab1')" type="text" formControlName="txtsold_projectedsaledate" [(ngModel)]="trade1031InputModel.sold_projectedsaledate">
                  <i class="icofont icofont-ui-calendar icon"></i>
                  <div *ngIf="(txtsold_projectedsaledate.invalid && istraderInfoSubmitted )||(txtsold_projectedsaledate.invalid && (txtsold_projectedsaledate.dirty || txtsold_projectedsaledate.touched))">
                    <p class="redtext" *ngIf="txtsold_projectedsaledate.errors.required">
                      Sold/Projected Sale Date is required
                    </p>
                    <p class="redtext" *ngIf="trade1031InputModel.sold_projectedsaledate =='Invalid Date' ">
                      Invalid Sold/Projected Sale Date
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Total Sale Price<span class="red">*</span></label>
                <div class="textbox-with-btn-left">
                  <input class="form-control" formControlName="txttotalsaleprice" id="SalePrice" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="trade1031InputModel.totalsaleprice" value="{{trade1031InputModel.totalsaleprice|number}}" maxlength="18"><span class="leftlabel">$</span>
                  <div *ngIf="(txttotalsaleprice.invalid && istraderInfoSubmitted )||(txttotalsaleprice.invalid && (txttotalsaleprice.dirty || txttotalsaleprice.touched))">
                    <p class="redtext" *ngIf="txttotalsaleprice.errors.required">
                      Total Sale Price is required
                    </p>
                    <p class="redtext" *ngIf="txttotalsaleprice.errors.min">
                      Total Sale Price should be greater than zero
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group ">
                <label class="form-label">Total Equity</label>
                <div class="textbox-with-btn-left">
                  <input class="form-control" formControlName="txttotalequity" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="trade1031InputModel.totalequity" value="{{trade1031InputModel.totalequity|number}}" maxlength="18"><span class="leftlabel">$</span>
                  <!--<p class="redtext" *ngIf="txttotalequity.errors.min">
                      Total Equity should be greater than zero
                  </p>-->
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Total Debt</label>
                <div class="textbox-with-btn-left">
                  <input class="form-control" formControlName="txttotaldebt" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="trade1031InputModel.totaldebt" value="{{trade1031InputModel.totaldebt|number}}" maxlength="18"><span class="leftlabel">$</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group">
                <label class="form-label">Address</label>
                <input class="form-control" formControlName="txtaddress" maxlength="100" [(ngModel)]="trade1031InputModel.address">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  State
                </label>
                <label class="select">
                  <select class="form-control" (change)="bindCity($event)" id="state" #state formControlName="txtstate" [(ngModel)]="trade1031InputModel.state">
                    <option value="0">--Select--</option>
                    <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                  </select>
                  <i></i>
                </label>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  City
                </label>
                <label class="select">
                  <select class="form-control" formControlName="txtcity" (change)="selectCity($event)" id="City" [(ngModel)]="trade1031InputModel.city">
                    <option value="0">--Select--</option>
                    <option *ngFor="let cities of citiesList" [(ngValue)]="cities.Id">{{cities.Name}}</option>
                  </select>
                  <i></i>
                </label>
              </div>
            </div>
          </div>
        </form>

        <div class="margin-bottom-0">
          <!--<h2 class="mainhead"><span class="text">1031 Trade Criteria</span></h2>-->
          <label class="bluelabel margin-top-10 margin-bottom-15">1031 Trade Criteria</label>
          <label class="form-label">Interested Property Type(s)</label>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox margin-bottom-30">
              <label class="custom-checkbox">
                <input type="checkbox" [(ngModel)]="selectAllAssetTypeValue" (keydown)="onKeydown($event,'tab2')" (change)="assetsCheckAll($event);">
                Select All
                <i></i>
              </label>
              <label class="custom-checkbox" *ngFor="let assets of assetType">
                <input type="checkbox" [(ngModel)]="assets.selected" (keydown)="onKeydown($event,'tab2')" (change)="assetsChecked(assets.id,$event);">
                {{assets.description}}
                <i></i>
              </label>
            </div>
          </div>
          <label class="form-label">Interested Geography(s)</label>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox  margin-bottom-30">
              <label class="custom-checkbox">
                <input type="checkbox" [(ngModel)]="selectAllgeographyValue" (keydown)="onKeydown($event,'tab2')" (change)="geographyCheckAll($event);">
                Select All
                <i></i>
              </label>
              <label class="custom-checkbox" *ngFor="let geo of geography">
                <input type="checkbox" [(ngModel)]="geo.selected" (keydown)="onKeydown($event,'tab2')" (change)="geographyChecked(geo.id,$event);">
                {{geo.description}}
                <i></i>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  margin-bottom-30">
              <label class="form-label">Identification Strategy</label>
              <div class="form-radio">
                <div class="radio radio-inline" *ngFor="let strategy of strategies;let i = index">
                  <label>
                    <input type="radio" [(ngModel)]="strategyModel" (keydown)="onKeydown($event,'tab2')" name="strategies" [value]="strategy.id" (change)="strategyChange(strategy.id,strategy.description);">
                    <i class="helper"></i>{{strategy.description}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <label class="form-label">Expected Cap Rate</label>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="margin-bottom-20 row">
                    <div class="resp-col">
                      <div class="textbox-with-btn textbox-with-2character">
                        <input type="text" class="search-field-input form-control" (keydown)="onKeydown($event,'tab2')" [dropSpecialCharacters]="false" mask="999.99" (change)="_validationService.onlyDecimal($event);" [(ngModel)]="trade1031InputModel.capratemin" placeholder="- Min -">
                        <span class="rightlabel">%</span>
                      </div>
                      <div>
                        <p class="redtext" *ngIf="trade1031InputModel.capratemin>100">
                          Cap Rate cannot be greater than 100
                        </p>
                        <p class="redtext" *ngIf="trade1031InputModel.capratemin<0">
                          Cap Rate cannot be less than 0
                        </p>
                      </div>

                      <span class="minusspan">-</span>
                    </div>
                    <div class="resp-col">
                      <div class="textbox-with-btn textbox-with-2character">
                        <input type="text" class="search-field-input form-control" (keydown)="onKeydown($event,'tab2')" [dropSpecialCharacters]="false" mask="999.99" (change)="_validationService.onlyDecimal($event);" [(ngModel)]="trade1031InputModel.capratemax" placeholder="- Max -">
                        <span class="rightlabel">%</span>
                      </div>
                      <div>
                        <p class="redtext" *ngIf="trade1031InputModel.capratemax>100">
                          Cap Rate cannot be greater than 100
                        </p>
                        <p class="redtext" *ngIf="trade1031InputModel.capratemax<0">
                          Cap Rate cannot be less than 0
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <label class="form-label">Expected Rent/NOI</label>
              <div class="row">
                <form [formGroup]="traderCriteria" autocomplete="off">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="margin-bottom-20 row">
                      <div class="resp-col">
                        <div class="textbox-with-btn-left">
                          <input type="text" class="form-control" formControlName="txtRentMin" (keydown)="onKeydown($event,'tab2')" (change)="_validationService.onlyDecimal($event);" [(ngModel)]="trade1031InputModel.rentmin" value="{{_validationService.decimalCommaFormat(trade1031InputModel.rentmin)}}" currencyMask maxlength="21" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" placeholder="- Min -">
                          <span class="leftlabel">$</span>
                        </div>
                        <span class="minusspan">-</span>
                      </div>
                      <div class="resp-col">
                        <div class="textbox-with-btn-left">
                          <input type="text" class="form-control" formControlName="txtRentMax" (keydown)="onKeydown($event,'tab2')" (change)="_validationService.onlyDecimal($event);" [(ngModel)]="trade1031InputModel.rentmax" value="{{_validationService.decimalCommaFormat(trade1031InputModel.rentmax)}}" currencyMask maxlength="21" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" placeholder="- Max -">
                          <span class="leftlabel">$</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
          <div class="row margin-top-30">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Preferred Exchange Location
                </label>
                <label class="select">
                  <select class="form-control" (change)="exchangelocationChange($event)" (keydown)="onKeydown($event,'tab2')" id="drpexchange" [(ngModel)]="trade1031InputModel.exchangestateid">
                    <option value="0">--Select State--</option>
                    <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                  </select>
                  <i></i>
                </label>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group">
                <label class="form-label">Any Additional Criteria</label>
                <textarea class="form-control property-description" [(ngModel)]="trade1031InputModel.specificpreferences" maxlength="2000" rows="3"></textarea>
              </div>
            </div>
          </div>

          <div class="text-right">
            <button type="button" class="btn btn-default btn-lg  margin-bottom-10" (click)="onCancel();">Cancel</button>
            <button class="btn btn-success btn-lg  margin-bottom-10" (click)="submit(templateSuccess,'')">Submit</button>
          </div>
        </div>
      </div>
      <div class="border-div successstep margin-bottom-0" *ngIf="showSuccessDiv">
        <div class="tick"><span class="icon-tick2 icon"></span></div>
        <h4>Inquiry submitted successfully!</h4>
        <h6>Our Broker will get in touch with you soon.</h6>
        <div class="text-right margin-top-20">
          <button class="btn btn-success btn-lg " (click)="onContinue()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templateSuccess class="success-placeoffer">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Thanks for filling out our form!</h4>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Our Broker will get in touch with you soon.</h6>
    </div>
    <div class="text-right">
      <a class="btn btn-success btn-lg " href="javascript:void(0);" (click)="onCancel();modalRef.hide();">Ok</a>
    </div>
  </div>
</ng-template>

